import { X } from 'lucide-react';
import { useTranslate } from '../lib/i18n';
import { Survey } from '../services/surveyBackendService';
import Selector from './common/Selector';
import { Button } from './ui/button';

interface AnswerSelectorProps {
  question: Survey['questions'][0];
  questionIndex: number;
  selectedAnswers: string | string[];
  onAnswerClick: (questionIndex: number, answer: string) => void;
  onClose?: () => void;
}

const AnswerSelector = ({
  question,
  questionIndex,
  selectedAnswers,
  onAnswerClick,
  onClose,
}: AnswerSelectorProps) => {
  const t = useTranslate();
  const isMultipleChoice = question.questionType === 'multipleChoice';

  return (
    <div className="w-full border rounded-md bg-popover py-3 px-3 space-y-4 text-popover-foreground relative">
      {onClose && (
        <Button className="absolute top-1 right-2" variant="ghost" size="icon-lg" onClick={onClose}>
          <X className="size-6" />
        </Button>
      )}
      <div className="pr-8">
        <div>{question.mainText}</div>
        {isMultipleChoice && (
          <span className="text-muted-foreground text-sm">{t('riku.multipleChoicesInfo')}</span>
        )}
      </div>

      <div className="space-x-2 space-y-2">
        {question.answerOptions.map((option, optionIndex) => {
          const optionText = option.mainQuestion || '';
          const optionKey = option.translationKey || '';
          const isSelected = isMultipleChoice
            ? Array.isArray(selectedAnswers) && selectedAnswers.includes(optionKey)
            : selectedAnswers === optionKey;

          return (
            <Selector
              key={`opt-${questionIndex}-${optionIndex}`}
              onClick={() => {
                if (!isMultipleChoice && isSelected) {
                  onAnswerClick(questionIndex, '');
                } else {
                  onAnswerClick(questionIndex, optionKey);
                }
              }}
              text={optionText}
              variant={isSelected ? 'selected' : 'active'}
            />
          );
        })}
      </div>

      {isMultipleChoice && onClose && (
        <Button variant="outline" onClick={onClose} className="w-full">
          {t('common.buttons.done')}
        </Button>
      )}
    </div>
  );
};

export default AnswerSelector;
